<template>
  <div :class="{ 'add-select': add }">
    <el-select
      v-model="selected"
      size="small"
      filterable
      remote
      clearable
      @change="handleChange"
      :remote-method="requestOptions"
      :loading="loading"
      placeholder="搜索并选择"
      :popper-append-to-body="false"
      :class="{ long: !add }"
      style="width: 100%"
    >
      <el-option
        v-for="item in options"
        :key="item.id"
        :label="item.whole_name"
        :value="item.id"
      ></el-option>
    </el-select>

    <el-button
      v-if="add"
      type="primary"
      plain
      class="ml-10"
      size="small"
      icon="el-icon-plus"
      @click="addNewOption"
      >新建</el-button
    >
    <NewFormer
      :model="newModel"
      :show.sync="addFormVisible"
      @created="createdCallback"
    ></NewFormer>
  </div>
</template>

<script>
import { customerDeviceAddressList } from '../../service/getData'
import NewFormer from '@/components/customer_device_address'

export default {
  components: {
    NewFormer,
  },
  props: {
    value: '',
    customerID: 0,
    add: false,
  },
  watch: {
    value: function (v) {
      if (!v) {
        this.selected = ''
      } else if (this.options.length == 0) {
        this.requestDefaultOption()
      }
    },
    customerID: function (v) {
      this.newModel.customer_id = v || 0
      if (v) {
        this.requestOptions('all')
      }
    },
  },
  data() {
    return {
      selected: '',
      options: [],
      loading: false,
      addFormVisible: false,
      newModel: {
        customer_id: this.customerID,
        area: [],
        detail: '',
      },
    }
  },
  created() {
    if (this.value > 0) {
      this.requestDefaultOption()
    }
  },
  mounted() {
    this.$nextTick(() => {
      Array.from(document.getElementsByClassName('el-select')).forEach(
        (item) => {
          item.children[0].children[0].removeAttribute('readOnly')
          item.children[0].children[0].onblur = function () {
            let _this = this
            setTimeout(() => {
              _this.removeAttribute('readOnly')
            }, 200)
          }
        }
      )
    })
  },
  methods: {
    handleChange() {
      this.$emit('input', parseInt(this.selected) || 0)
    },
    createdCallback(res) {
      this.options.push(res)
      this.selected = res.id
      this.$emit('input', parseInt(this.selected) || 0)
    },
    addNewOption() {
      if (!this.customerID) {
        this.$alert('请先选择客户')
        return
      }
      this.addFormVisible = true
    },
    async requestDefaultOption() {
      let res = await customerDeviceAddressList({
        id: this.value,
        customer_id: this.customerID || 0,
      })
      this.options = res.data.list
      this.selected = this.value
    },
    async requestOptions(query) {
      if (query !== '') {
        this.loading = true
        query = query == 'all' ? '' : query
        let data = {
          query: query,
          customer_id: this.customerID || 0,
        }
        let res = await customerDeviceAddressList(data)
        this.loading = false
        this.options = res.data.list

        if (!query && this.options.length > 0) {
          this.selected = this.options[0].id
          this.$emit('input', parseInt(this.selected) || 0)
        }
      } else {
        this.options = []
      }
    },
  },
}
</script>